import { useState, useCallback } from "react";
import { authApi } from "../api/auth";

const TOKEN_KEY = "sv_token";

export function useAuth() {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState<{ id: string; email: string; role: string; name: string | null; allow_external_send: boolean; is_super_admin: boolean } | null>(null);

  const login = useCallback(async (email: string, password: string) => {
    const data = await authApi.login(email, password);
    localStorage.setItem(TOKEN_KEY, data.token);
    setToken(data.token);
    setUser(data.user);
    return data;
  }, []);

  const logout = useCallback(async () => {
    if (token) {
      try { await authApi.logout(token); } catch { /* ignore */ }
    }
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(null);
  }, [token]);

  return { token, user, login, logout, isAdmin: user?.role === "admin" };
}
